function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone';
/**
 * Model containing attributes for each player score object within the
 * leaderboard collection.
 */

var PlayerScore = /*#__PURE__*/function (_Backbone$Model) {
  _inheritsLoose(PlayerScore, _Backbone$Model);

  function PlayerScore() {
    return _Backbone$Model.apply(this, arguments) || this;
  }

  var _proto = PlayerScore.prototype;
  /**
   * Returns whether the player placed an answer for the specified question
   * regardless of correctness.
   * @param {string} participantKey Poll question's participant key
   * @return {boolean} True if an answer was placed for this question.
   */

  _proto.answered = function answered(participantKey) {
    if (!participantKey) {
      return false;
    }

    return participantKey in this.get('discrete_scores');
  }
  /**
   * Returns whether the player answered the specified question correctly.
   * @param {string} participantKey Poll question's participant key
   * @return {boolean} True if answered correctly and earned points.
   */
  ;

  _proto.answeredCorrect = function answeredCorrect(participantKey) {
    if (!participantKey) {
      return false;
    }

    return this.scoreFor(participantKey) > 0;
  }
  /**
   * Returns the player's score earned from the specified question.
   * @param {string} participantKey Poll question's participant key
   * @return {number}
   */
  ;

  _proto.scoreFor = function scoreFor(participantKey) {
    if (!participantKey) {
      return 0;
    }

    return this.get('discrete_scores')[participantKey] || 0;
  }
  /**
   * Returns the player's previous total score before the specified question.
   * @param {string} participantKey Poll question's participant key
   * @return {number}
   */
  ;

  _proto.scoreWithout = function scoreWithout(participantKey) {
    if (!participantKey) {
      return this.totalScore();
    }

    return this.totalScore() - this.scoreFor(participantKey);
  }
  /**
   * Returns the player's total score up to this point.
   * @return {number}
   */
  ;

  _proto.totalScore = function totalScore() {
    return this.get('score') || 0;
  }
  /**
   * Returns the player's screen name. The value returned will either be what
   * was hydrated by the backend or the local hash-generated value when
   * screen names are disabled by the presenter.
   * @return {string}
   */
  ;

  _proto.screenName = function screenName() {
    return !this.collection || this.collection.screenNamesEnabled ? this.get('screen_name') : this.collection.generateScreenName(this.id);
  };

  _createClass(PlayerScore, [{
    key: "defaults",
    get:
    /**
     * Define default values for model attributes.
     * @return {Object}
     */
    function get() {
      return {
        abbreviation: '?',
        rank: 0,
        score: 0,
        discrete_scores: {},
        screen_name: 'Unknown'
      };
    }
  }]);

  return PlayerScore;
}(Backbone.Model);

export { PlayerScore as default };